/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ProjectOtherNameDTO
 */
export interface ProjectOtherNameDTO  {
    /**
     * 
     * @type {number}
     * @memberof ProjectOtherNameDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectOtherNameDTO
     */
    otherName?: string;
}

/**
 * Check if a given object implements the ProjectOtherNameDTO interface.
 */
export function instanceOfProjectOtherNameDTO(value: object): value is ProjectOtherNameDTO {
    return true;
}

export function ProjectOtherNameDTOFromJSON(json: any): ProjectOtherNameDTO {
    return ProjectOtherNameDTOFromJSONTyped(json, false);
}

export function ProjectOtherNameDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectOtherNameDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'otherName': json['otherName'] == null ? undefined : json['otherName'],
    };
}

export function ProjectOtherNameDTOToJSON(json: any): ProjectOtherNameDTO {
    return ProjectOtherNameDTOToJSONTyped(json, false);
}

export function ProjectOtherNameDTOToJSONTyped(value?: ProjectOtherNameDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'otherName': value['otherName'],
    };
}


